module.exports = __webpack_public_path__ + "img/tarrif-change-warning.e0637d04.svg";